/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import '../text_wrapper.scss';

// eslint-disable-next-line no-empty-pattern
const About = ({
  handlePageChange,
}) => {
  return (
    <div key="wf-About-Items" id="wf-About-Items">
      {/* <p className="wf-card__item wf-card__item--clickable" onClick={() => handlePageChange('About')}>1WordFlow Solutions for Aged Care</p> */}
      <p className="wf-card__item wf-card__item--clickable" onClick={() => handlePageChange('AboutVideo')}>Digital Solutions for Aged Care</p>
      <p className="wf-card__item wf-card__item--clickable"><a target="_blank" href="https://1wordflow.info/" rel="noreferrer">1WordFlow Website</a></p>
    </div>
  );
};

export default About;
